import React, { useState } from "react";
import "./Tabs.css";

const GRDuringTheCompetition = () => {
  const [activeTab, setActiveTab] = useState("safety");

  return (
    <div className="rules-container">
      <h1 className="rules-title">General rules during the competition</h1>

      {/* Navigation Tabs */}
      <div className="rules-tabs">
        <button
          className={`tab ${activeTab === "safety" ? "active" : ""}`}
          onClick={() => setActiveTab("safety")}
        >
          PARTICIPANT SAFETY
        </button>
        <button
          className={`tab ${activeTab === "environmental" ? "active" : ""}`}
          onClick={() => setActiveTab("environmental")}
        >
          ENVIRONMENTAL PROTECTION
        </button>
        <button
          className={`tab ${activeTab === "state" ? "active" : ""}`}
          onClick={() => setActiveTab("state")}
        >
          STATE RULES
        </button>
        <button
          className={`tab ${activeTab === "behavior" ? "active" : ""}`}
          onClick={() => setActiveTab("behavior")}
        >
          SPORTING BEHAVIOR
        </button>
      </div>

      {/* Content */}
      <div className="rules-content">
        {activeTab === "safety" && (
          <div className="content">
            <img
              src="./gallery/VLD_8803.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              The helmet and seat belt are mandatory throughout the race (on and
              off) for the TROPHY and ADVENTURE classes. Wearing a helmet is
              punishable by disqualification for a particular stage or SS.
              Wearing a belt is punishable by disqualification for a particular
              stage or SS. It is strictly forbidden to consume alcohol on the
              course, as well as while driving. A participant who is found to be
              under the influence of alcohol by an alcohol test (anywhere on the
              track) will be disqualified and removed from the competition.
            </p>
          </div>
        )}
        {activeTab === "environmental" && (
          <div className="content">
            <img
              src="./gallery/VLD_8926.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              It is forbidden to throw trash on the trail or in any other place
              not provided for this. Each vinting around a tree, without a tree
              lane, is penalized with 1,000 penalty points. Any deliberate
              felling of trees is punishable by 5,000 penalty points. All crews
              must take care of their private property. Unless they are on the
              right path and come across private property or planted land, they
              MUST NOT move on the same property. Otherwise they will bear the
              costs if a lawsuit arises..
            </p>
          </div>
        )}
        {activeTab === "state" && (
          <div className="content">
            <img
              src="./gallery/VLD_9948.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              As part of the route leads through populated areas and public
              roads, all participants are obliged and obliged to act in
              accordance with existing traffic regulations.
            </p>
          </div>
        )}
        {activeTab === "behavior" && (
          <div className="content">
            <img
              src="./gallery/VLD_9691.jpg"
              alt="Offroad"
              className="content-image"
              loading="lazy"
            />
            <p>
              Any crew which for some reason is lagging or malfunctioning is
              obliged to miss the vehicle moving behind them if, of course, the
              terrain permits. Assistance to other competing teams is allowed,
              if the team is able and if desired. In the event of an accident,
              especially if there are injuries, all participants are obliged to
              assist the organizers as soon as possible. The Organizer
              undertakes to pull out all vehicles remaining on the ground for
              some reason until the end of the race.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GRDuringTheCompetition;
